import { Loader } from 'semantic-ui-react'
import * as S from './styles'

export default function Loading() {
    return <S.Container><Loader active /></S.Container>
}